import { TrackShipmentQueryResponse } from "../apiModels/trackShipmentQueryResponse";
import apiPaths from "./apiPaths";
import { get } from "./apiUtilities";

export const trackShipments = async (trackingNumbers: string[]): Promise<TrackShipmentQueryResponse[]> => 
    await get(`${apiPaths.trackShipments}?${trackingNumbers.map(tn => `trackingNumbers=${tn}`).join('&')}`);
